module.exports = __webpack_public_path__ + "img/indeximg4.6be52c83.png";